export default __webpack_public_path__ + "static/Episode3-da5d49bcd11720596f258795ba73c107.mp3";